'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useSession } from 'next-auth/react';
import { SharedFooter } from './SharedFooter';

export function Container({ children }) {
  const { data: session } = useSession();

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      {/* Navigation Bar */}
      <nav className="sticky top-0 z-50 bg-white shadow-md">
        <div className="container mx-auto px-6 py-4 max-w-7xl flex justify-between items-center">
          <Link href="/" className="flex items-center">
            <Image 
              src="/bdnog.svg" 
              alt="BDNOG Logo" 
              width={150} 
              height={45} 
              priority
            />
          </Link>
          <div className="hidden md:flex space-x-6 items-center">
            <Link href="/events" className="text-gray-600 hover:text-gray-900">
              Events
            </Link>
            <a 
              href="https://bdnog.org" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900"
            >
              Contact
            </a>
            {session ? (
              <Link 
                href="/user/dashboard" 
                className="px-4 py-2 bg-[#10B981] text-white rounded-md hover:bg-[#3B82F6] transition-colors font-medium"
              >
                Dashboard
              </Link>
            ) : (
              <div className="space-x-4">
                <Link 
                  href="/auth/signin" 
                  className="px-4 py-2 border border-[#10B981] text-[#10B981] rounded-md hover:bg-[#10B981] hover:text-white transition-colors font-medium"
                >
                  Sign In
                </Link>
                <Link 
                  href="/auth/signup" 
                  className="px-4 py-2 bg-[#10B981] text-white rounded-md hover:bg-[#3B82F6] transition-colors font-medium"
                >
                  Register
                </Link>
              </div>
            )}
          </div>
        </div>
      </nav>
      
      {/* Main content */}
      <div className="container mx-auto px-6 max-w-7xl py-12">
        {children}
      </div>
      <SharedFooter />
    </div>
  );
}
